import { Component, Input, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { finalize } from 'rxjs/operators';
import { ToastService } from '../../../_core/services/toast.service';
import { UserService } from '../../../_core/services/user.service';
import { User } from '../../models/user.model';
interface ImageUploadedData {
  image: any;
  imageChanged: boolean;
}
@Component({
  selector: 'app-add-coach',
  templateUrl: './add-coach.component.html',
  styleUrls: ['./add-coach.component.scss'],
  standalone: false
})
export class AddCoachComponent implements OnInit {
  @Input() user: User;
  @Input() editModal: boolean;

  form: UntypedFormGroup;
  submittingForm = false;
  isEdit = false;
  private _userImage: ImageUploadedData;

  constructor(
    private userService: UserService,
    private fb: UntypedFormBuilder,
    private modalCtrl: ModalController,
    private toastService: ToastService
  ) {}

  ngOnInit() {
    !this.user ? (this.user = new User()) : (this.isEdit = true);
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      first_name: [
        this.user.first_name,
        [Validators.required, Validators.minLength(1)],
      ],
      last_name: [
        this.user.last_name,
        [Validators.required, Validators.minLength(1)],
      ],
      sex: [this.user?.biographicalInformation?.sex],
      
    });
  }  
  async submit() {
    if (this.form.valid) {
      this.submittingForm = true;

      const formData = new FormData();
      Object.keys(this.form.value).forEach((key) => {
        if(this.form.value[key]===null||this.form.value[key]===undefined) return;
        formData.append(key, this.form.value[key]);
      });
     
      // Handle profile_image if it's available
      if (this._userImage?.image) {
        const blob = await fetch(this._userImage?.image).then((res) =>
          res.blob()
        );
        formData.append('profile_image', blob);
      } else {
        formData.append('profile_image', ''); // Add empty string if no image
      }
      formData.append('isImageChange', (this._userImage?.imageChanged || false).toString());

      if (!this.isEdit) {
        this.userService
          .create(formData)
          .pipe(finalize(() => (this.submittingForm = false)))
          .subscribe(
            (res) => {
              this.toastService.presentToast(res.message);
              this.modalCtrl.dismiss(res.data);
            },
            (err) => {
              //console.log(err)
            }
          );
      } else {
        this.userService
          .update(this.user._id, formData)
          .pipe(finalize(() => (this.submittingForm = false)))
          .subscribe(
            (res) => {
              this.modalCtrl.dismiss({
                ...this.user,
                ...res.data, 
              });
            },
            (err) => {
              //console.log(err)
            }
          );
      }
    } else {
      this.handleErrors();
    }
  }

  handleErrors() {
    let errorMessage = '';
    if (this.form.get('first_name')?.invalid) {
      errorMessage = 'First name is required.';
    } else if (this.form.get('last_name')?.invalid) {
      errorMessage = 'Last name is required.';
    }
    this.toastService.presentDangerToast(errorMessage);
  }

  close() {
    this.modalCtrl.dismiss();
  }

  clear() {
    this.form.reset();
  }

  imageSelected(data: ImageUploadedData) {
    this._userImage = data;
  }
}
